(()=>{"use strict";
const tag=document.getElementById("suki-contact-tracker");
if(!tag||window.__sukiWholesaleTrackerV1)return;
window.__sukiWholesaleTrackerV1=true;
const market=tag.dataset.market==="ID"?"ID":"PH";
const channel=market==="ID"?"whatsapp":"messenger";
const pageType=tag.dataset.pageType||"other";
function placement(el){
if(el.closest("#sukiWholesaleDialog"))return"wholesale_dialog";
if(el.closest(".sj-wa-float,.suki-messenger-widget"))return"floating";
if(el.closest("header,#header-group"))return"header";
if(el.closest("footer"))return"footer";
if(el.closest("[data-suki-product-title],.product-card,.product-card-wrapper"))return"product_card";
if(location.pathname.includes("/products/"))return"product_detail";
return"other";
}
function publish(name,el){
const payload={market:market,channel:channel,page_type:pageType,page_path:location.pathname,button_placement:placement(el),event_schema_version:"1"};
try{const api=window.Shopify&&window.Shopify.analytics;if(api&&typeof api.publish==="function"){const p=api.publish(name,payload);if(p&&typeof p.catch==="function")p.catch(()=>{});}}catch(e){}
}
function targetChannel(anchor){
try{const url=new URL(anchor.href,location.href),host=url.hostname.toLowerCase();
if(host==="wa.me"||host==="api.whatsapp.com"||host==="web.whatsapp.com")return"whatsapp";
if(host==="m.me"||host==="www.m.me"||host==="messenger.com"||host==="www.messenger.com"||((host==="facebook.com"||host==="www.facebook.com")&&url.pathname.startsWith("/messages")))return"messenger";
}catch(e){}
return"";
}
document.addEventListener("click",function(event){
const target=event.target instanceof Element?event.target:null;
if(!target)return;
if(market==="PH"){
const launch=target.closest(".suki-messenger-widget__launcher");
if(launch&&launch.parentElement&&!launch.parentElement.open)publish("wholesale_inquiry_open",launch);
const inquiry=target.closest("[data-suki-inquiry]");
if(inquiry&&!inquiry.disabled)publish("wholesale_inquiry_open",inquiry);
const open=target.closest("#sukiInquiryCopyOpen");
if(open&&!open.disabled){publish("wholesale_contact_click",open);return;}
}
const link=target.closest("a[href]");
if(link&&targetChannel(link)===channel)publish("wholesale_contact_click",link);
},true);
})();